const _0 = "0"
const _1 = "1"
const _infinite = "infinite"
const config = { "0": _0, "1": _1, "infinite": _infinite,  }
export { config as default, _0, _1, _infinite }